import { NonNullableDate } from "../../utils/date-time-utility";
import { getFormattedId, replaceUnderScoreAddSpace } from "../../utils/utils";
import { checkNull, ListContent, ReportContainer } from "../constant";

interface PrescriptionsBlockProps {
  data: any;
}

const formatEnum = (value?: string | null) =>
  value ? replaceUnderScoreAddSpace(value.toLowerCase()) : "";

const joinParts = (parts: Array<string | false | null | undefined>) =>
  parts.filter(Boolean).join(" - ");

// Mirrors the visit-note Prescription preview (PrescriptionPreview) so the
// encounter summary shows the same fields and order (ECRH-5428).
const PrescriptionsBlock = ({ data }: PrescriptionsBlockProps) => {
  if (!checkNull(data?.patientPrescriptionForms)) return null;

  // `flow` lets a long prescription list continue on the next page instead of
  // being bumped to it whole, which left a blank block behind it.
  return (
    <ReportContainer label="Prescription" flow>
      <ListContent
        list={data?.patientPrescriptionForms}
        renderItem={(item, ind) => {
          const line = joinParts([
            `OrderId: ${getFormattedId(item?.uuid)}`,
            item?.prescriptionFormType &&
              `Prescription Form Type: ${formatEnum(
                item?.prescriptionFormType
              )}`,
            item?.prescriptionDate &&
              `Prescribe Date: ${NonNullableDate(item?.prescriptionDate)}`,
            item?.prescriptionStatus &&
              `Prescription Status: ${formatEnum(item?.prescriptionStatus)}`,
          ]);

          return (
            <p
              key={item?.uuid ?? ind}
              style={{ margin: "5px 0", fontSize: "14px" }}
            >
              {ind + 1}. {line}
            </p>
          );
        }}
      />
    </ReportContainer>
  );
};

export default PrescriptionsBlock;
